export default {
    page: function() {
        this.loadUsers()
    }
}
